<template>
  <div id="app">
    <el-container>
      <el-header>
        <!-- 头部 -->
        <commonHeader />
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <!-- 底部 -->
      <commonFooter />
    </el-container>
  </div>
</template>

<script>
import commonFooter from './components/footer/index.vue'
import commonHeader from './components/header/index.vue'
export default {
  components: { commonFooter, commonHeader },
  data() {
    return {
      activeIndex: '/',
    }
  },
  methods: {},
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
::-webkit-scrollbar {
  display: none; /* ChromeSafari */
}
// .el-container {
//   padding-top: 60px;
// }

.el-main {
  padding: 0 !important;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 0 0 !important;
  // border-bottom: 1px solid #3e4350;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 60px;
  z-index: 998;
  
}
</style>
